
import { Checkbox, Stack } from "@mui/material";
import { useController } from "react-hook-form";

import { Theme } from "../../../Style/Theme";
import Label from "./Label";

export const CheckBoxInput = ({
  text,
  marginTop,
  control,
  name,
  disable,
  readOnly,
  justifyContent = "center",
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
    disabled: disable || readOnly,
  });

  return (
    <Stack
      id="check"
      direction={"row"}
      alignItems={"center"}
      justifyContent={justifyContent}
      marginTop={marginTop}
    >

      <Checkbox
        disabled={disable || readOnly}
        sx={{ borderRadius: "10px", color: Theme.palette.background.grayLight }}
        error={fieldState?.invalid}
        helperText={fieldState?.error?.message}
        {...field}
        value={field.value}
        checked={field.value}
        readOnly={readOnly}
      />
      <Label label={text} />
    </Stack>
  );
};
